// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6cbfa350","703":"9bca7069"}[chunkId] + ".chunk.js";
};